<template>
  <div v-if="content.show" class="field" :class="content.errorMessage?'errorBorder':''">
    <p class="text">
      <span>{{content.order}}</span>{{content.title}}
    </p>
    <div class="scale-div">
      <table>
        <thead>
          <tr class="trlabel">
            <th v-for="(item,index) in content.titleArr">
              {{item}}
            </th>
          </tr>
        </thead>
        <template v-for="(i,sindex) in content.answer">
          <tr>
            <td colspan="9" class="tdtitle">{{i}}、{{content.subTitle[i-1]}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in answer" @click="selectCurrent(index,content.num,content.type,item,i-1)">
              <a class="rate-off" :class="selected[i-1][index]?'rate-on':''">{{item}}</a>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
  export default {
    props:{
      content: Object
    },
    data() {
      return {
        answer: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        selected: [
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false]
        ]
      }
    },
    updated(){
      let status = true
      this.selected.map((item,index)=>{
        if(status){
          let value = [false, false, false, false, false, false, false, false, false]
          if(item.indexOf(true)>=0&&this.content.answer.indexOf(index+1)<0){
            this.$set(this.selected,index,value)
            status = false
          }
        }
      })
    },
    methods: {
      selectCurrent: function(index, num, type, item, s) {
        let value = [false, false, false, false, false, false, false, false, false]
        value[index] = true
        if (s + 1) {
          this.$set(this.selected, s, value)
        }else{
          this.$set(this.selected, 0, value)
        }
        this.$emit("listenToChildEvent", index, num, type, s+1)
      }
    }
  }
</script>
<style lang="stylus" scoped>
  table
    width: 100%
    background-color: #ffffff

  table th
    width: 9%
    text-align:center
    font-weight:normal

  table th:first-child,
  table th:last-child
    width: 13%

  table tr td
    text-align:center
    padding:0.1rem 0 0.16rem 0

  table tr .tdtitle
    text-align:left
    padding:0.1rem 0 0 0
  .trlabel
    background: #EFF6FB
    font-size: 0.28rem
    color: #444
    height: 0.6rem

  .scale-div
    width: 94%
    background: #fff
    margin: auto
    padding: 0.1rem
    border:1px solid #d5d5d5

  .rate-off
    width: 21px
    height: 21px
    text-decoration: none
    border-radius: 30px
    color: #333
    border: 1px solid #cacece
    cursor: default
    display: inline-block
    background: #fafafa
    line-height: 19px
    text-align: center

  .rate-on
    background-color: #53a4f4 !important
    border: 1px solid #53a4f4
    position: relative
    color: #fff
</style>
